const ENV = import.meta.env.VITE_VERCEL_TARGET_ENV ?? 'development'

function getCurrentDomain() {
  if (typeof window !== 'undefined') {
    return window.location.hostname
  }
}

const API_URL = (() => {
  const domain = getCurrentDomain()

  // Check for international custom domains first
  switch (domain) {
    case 'ca.app.bland.ai':
      return 'https://canada.api.bland.ai'
    case 'au.app.bland.ai':
      return 'https://asia.api.bland.ai'
    default:
      // Fall back to environment-based routing
      switch (ENV) {
        case 'preview':
          return 'https://staging.api.bland.ai'
        case 'production':
          return 'https://api.bland.ai'
        default:
          return 'http://localhost:3000'
      }
  }
})()

const FILE_UPLOAD_URL = ENV === 'development' ? 'http://localhost:8787' : API_URL

const WS_URL = (() => {
  switch (ENV) {
    case 'development':
      return 'ws://localhost:3000'
    case 'staging':
      return 'wss://api.staging.bland.ai'
    default:
      return undefined
  }
})()

const BILLING_ENDPOINT = `${API_URL}/billing`

const config = {
  ENV,
  API_URL,
  WS_URL,
  BILLING_ENDPOINT,
  FILE_UPLOAD_URL,
}

export default config
